export const photos = [
  {
    src: "Images/gallery/floor-01.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "Images/gallery/floor-02.jpg",
    width: 1,
    height: 1,
  },
  {
    src: "Images/gallery/floor-03.jpg",
    width: 3,
    height: 4,
  },
  {
    src: "Images/gallery/floor-04.jpg",
    width: 3,
    height: 4,
  },
  {
    src: "Images/gallery/floor-05.jpg",
    width: 3,
    height: 4,
  },
  {
    src: "Images/gallery/floor-06.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "Images/gallery/floor-07.jpg",
    width: 3,
    height: 4,
  },
  {
    src: "Images/gallery/floor-08.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "Images/gallery/floor-09.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "Images/gallery/floor-10.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "Images/gallery/floor-11.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "Images/gallery/floor-12.jpg",
    width: 4,
    height: 3,
  },
];
